import { Module } from 'vuex';
import { RootState } from '@/store';
import { getters } from '@/store/modules/backoffice/customer/getters';
import { actions } from '@/store/modules/backoffice/customer/actions';
import { mutations } from '@/store/modules/backoffice/customer/mutations';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { Grid } from '@/models/Grid.model';
import { ManagerPrivilegesModel } from '@/models/backoffice/ManagerPrivilegesModel';
import { SearchManagerModel } from '@/models/backoffice/SearchManagerModel';
import { LIST_ORG_UNITS } from '@/types/customer.types';
import { OrganisationUnitModel } from '@/models/backoffice/OrganisationUnitModel';

export interface CustomerState {
  allCustomers: Grid;
  allCustomersErrors: string[];
  customerDetails: CustomerDetailsModel;
  updateCustomerSettingsModal: boolean;
  updateCustomerSettingsModalErrors: string[];
  allOfficesByCustomer: Grid;
  officeDetails: CustomerDetailsModel;
  allOfficesErrors: string[];
  updateOfficeSettingsModal: boolean;
  updateOfficeSettingsModalErrors: string[];
  allRemindersByCustomer: Grid;
  openCreateRemindersModal: boolean;
  openCreateRemindersModalErrors: string[];
  managersByCustomer: Grid;
  managerToAdd: Grid;
  managerToDelete: ManagerPrivilegesModel | null;
  openDeleteManagerModal: boolean;
  openDeleteManagerModalErrors: string[];
  managerToUpdate: ManagerPrivilegesModel | null;
  openUpdateManagerModal: boolean;
  openUpdateManagerModalErrors: string[];
  openUploadManagerPrivilegesModal: boolean;
  openUploadManagerPrivilegesModalErrors: string[];
  openAddManagerModal: boolean;
  openAddManagerModalErrors: string[];
  orgUnits: OrganisationUnitModel[];
  managerPrivileges: any;
  exportForm101Errors: string[];
  allSectionsByOffice : Grid;
  allSectionsErrors:string[];
}

export const initialState = ((): CustomerState => {
  return {
    allCustomers: {} as Grid,
    allCustomersErrors: [],
    customerDetails: {},
    updateCustomerSettingsModal: false,
    updateCustomerSettingsModalErrors: [],
    allOfficesByCustomer: {} as Grid,
    allOfficesErrors: [],
    officeDetails: {},
    updateOfficeSettingsModal: false,
    updateOfficeSettingsModalErrors: [],
    allRemindersByCustomer: {} as Grid,
    openCreateRemindersModal: false,
    openCreateRemindersModalErrors: [],
    managersByCustomer: {} as Grid,
    managerToAdd: {} as Grid,
    managerToDelete: null,
    openDeleteManagerModal: false,
    openDeleteManagerModalErrors: [],
    managerToUpdate: null,
    openUpdateManagerModal: false,
    openUpdateManagerModalErrors: [],
    openUploadManagerPrivilegesModal: false,
    openUploadManagerPrivilegesModalErrors: [],
    openAddManagerModal: false,
    openAddManagerModalErrors: [],
    orgUnits: [],
    managerPrivileges: {},
    exportForm101Errors: [],
    allSectionsByOffice : {} as Grid ,
    allSectionsErrors: []
  };
});

export const customer: Module<CustomerState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
